export class FavoritesService {
  constructor(gaApp) {
    this.gaApp = gaApp
  }

  /** Добавление продукта в стору Избранных */
  setItem(id) {
    if (!this.gaApp.stores.product.main.favorites.includes(id)) {
      this.gaApp.stores.product.main.favorites.push(id)
    }
  }

  /** Удаление продукта из сторы Избранных */
  removeItem(id) {
    const index = this.gaApp.stores.product.main.favorites.indexOf(id)

    if (index !== -1) {
      this.gaApp.stores.product.main.favorites.splice(index, 1)
    }
  }

  /** Отправка события на добавление продукта в избранное */
  addItem(item) {
    this.gaApp.services.app.bridge.sendAddToFavoritesMessage(item.id)
  }

  /** Отправка события на удаление продукта из избранного */
  deleteItem(item) {
    this.gaApp.services.app.bridge.sendRemoveFromFavoritesMessage(item.id)
  }
}
